export default __webpack_public_path__ + "static/media/GreenlinePOS-full.6dc5f1f6.svg";